export * from './education/externals';

export const Actions = Object.freeze({
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_VIEW_UPDATED: 'LOGIN_VIEW_UPDATED',
  REGISTER_VIEW_UPDATED: 'REGISTER_VIEW_UPDATED',
  REGISTER: 'REGISTER',
});

export const Errors = Object.freeze({
  USER_IS_UNDERAGE: 'User is underage',
});
